var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mt-swipe',{style:(_vm.getContainerStyle),attrs:{"showIndicators":_vm.isShowIndicators}},_vm._l((_vm.getItems),function(item,index){return _c('mt-swipe-item',{key:index},[_c('card-item',{style:(_vm.getContainerStyle),attrs:{"item":item}})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e64753b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/cardpage/group/CardGroupC1.vue
// module id = null
// module chunks = 